import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { SX } from "../sx";
import { C, F, R, maxW } from "../tokens";

const TARIFS = [
  {
    num: "01",
    name: "Consultation au cabinet",
    badge: "Standard",
    badgeStyle: { background: C.primaryLight, color: C.primary },
    sub: "Adultes, sportifs, femmes enceintes",
    price: "60",
  },
  {
    num: "02",
    name: "Consultation pédiatrique",
    badge: "Pédiatrie",
    badgeStyle: { background: "#E8F0EC", color: C.primary },
    sub: "Enfants de moins de 10 ans",
    price: "50",
  },
  {
    num: "03",
    name: "Soin à domicile",
    badge: "+ 10 € de déplacement",
    badgeStyle: { background: C.primaryLight, color: C.primary },
    sub: "Sur Balma & environs (20 km)",
    price: "70",
  },
  {
    num: "04",
    name: "Drainage lymphatique",
    badge: "Bien-être",
    badgeStyle: { background: "#F5EBE0", color: C.accent },
    sub: "Méthode Vodder  1h env.",
    price: "100",
  },
];

const TARIFS_ENTREPRISE = [
  { range: "1 à 3 personnes / jour", price: "65" },
  { range: "4 à 6 personnes / jour", price: "55" },
  { range: "7 personnes et plus / jour", price: "45" },
];

const TarifsRemboursements = () => (
  <>
    <SEO
      title="Tarifs ostéopathie & remboursements Balma"
      description="Consultation 60 €, pédiatrie 50 €, domicile 70 €, drainage lymphatique 100 €. Remboursement mutuelle sur facture. Interventions en entreprise disponibles."
      path="/tarifs-et-remboursements"
    />
    <Box component="section" sx={SX.pageHeroSection}>
      <Box sx={SX.pageHeroInner}>
        <Box component="span" sx={SX.sectionLabel}>
          Tarifs
        </Box>
        <Typography variant="h1" component="h1" sx={SX.displayTitle}>
          Transparents, <em>sans surprise.</em>
        </Typography>
        <Typography sx={SX.pageHeroSub}>
          Une facture est disponible sur demande pour vos remboursements
          mutuelle. Paiement en cabinet selon les modalités de chaque adresse.
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1rem", md: "2.5rem" },
        pb: "4rem",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
        gap: "1.5rem",
        alignItems: "stretch",
      }}
    >
      {/* Carte Particuliers */}
      <Box
        sx={{
          background: C.surface,
          border: `1px solid ${C.border}`,
          borderRadius: R.lg,
          padding: { xs: "1.5rem", md: "2rem" },
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: ".6rem",
            fontWeight: 600,
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            padding: ".2rem .55rem",
            borderRadius: "4px",
            background: C.primaryLight,
            color: C.primary,
            mb: ".75rem",
            display: "inline-block",
          }}
        >
          Particuliers
        </Box>
        <Typography sx={{ fontSize: ".95rem", fontWeight: 600, color: C.text }}>
          Consultations au cabinet
        </Typography>
        <Typography
          sx={{
            fontSize: ".8rem",
            color: C.textMuted,
            mt: ".25rem",
            mb: ".5rem",
          }}
        >
          Balma & Castelnau-d'Estrétefonds
        </Typography>
        {TARIFS.map((t) => (
          <Box
            key={t.num}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: "1rem",
              borderTop: `1px solid ${C.border}`,
              gap: "1rem",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: ".88rem",
                  fontWeight: 600,
                  color: C.text,
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                  flexWrap: "wrap",
                }}
              >
                {t.name}
                <Box
                  component="span"
                  sx={{
                    fontSize: ".58rem",
                    fontWeight: 600,
                    letterSpacing: "1.2px",
                    textTransform: "uppercase",
                    padding: ".15rem .45rem",
                    borderRadius: "4px",
                    ...t.badgeStyle,
                  }}
                >
                  {t.badge}
                </Box>
              </Typography>
              <Typography
                sx={{ fontSize: ".78rem", color: C.textMuted, mt: ".15rem" }}
              >
                {t.sub}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: F.display,
                fontSize: "1.9rem",
                fontWeight: 300,
                color: C.text,
                whiteSpace: "nowrap",
              }}
            >
              {t.price}
              <Box
                component="sup"
                sx={{
                  fontSize: "1rem",
                  fontWeight: 400,
                  verticalAlign: "super",
                }}
              >
                €
              </Box>
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Carte Entreprises */}
      <Box
        sx={{
          background: C.surface,
          border: `1px solid ${C.border}`,
          borderRadius: R.lg,
          padding: { xs: "1.5rem", md: "2rem" },
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: ".6rem",
            fontWeight: 600,
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            padding: ".2rem .55rem",
            borderRadius: "4px",
            background: "#F0EDE6",
            color: C.accent,
            mb: ".75rem",
            display: "inline-block",
          }}
        >
          Entreprises
        </Box>
        <Typography sx={{ fontSize: ".95rem", fontWeight: 600, color: C.text }}>
          Interventions en entreprise
        </Typography>
        <Typography
          sx={{
            fontSize: ".8rem",
            color: C.textMuted,
            mt: ".25rem",
            mb: ".5rem",
          }}
        >
          Déplacement sur site · Prix par personne / jour
        </Typography>
        {TARIFS_ENTREPRISE.map((t) => (
          <Box
            key={t.range}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: "1rem",
              borderTop: `1px solid ${C.border}`,
              gap: "1rem",
            }}
          >
            <Typography sx={{ fontSize: ".88rem", color: C.textMuted }}>
              {t.range}
            </Typography>
            <Typography
              sx={{
                fontFamily: F.display,
                fontSize: "1.9rem",
                fontWeight: 300,
                color: C.text,
                whiteSpace: "nowrap",
              }}
            >
              {t.price}
              <Box
                component="sup"
                sx={{
                  fontSize: "1rem",
                  fontWeight: 400,
                  verticalAlign: "super",
                }}
              >
                €
              </Box>
            </Typography>
          </Box>
        ))}
        <Box
          sx={{
            pt: "1rem",
            borderTop: `1px solid ${C.border}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: ".88rem", fontWeight: 600, color: C.text }}
            >
              Familles des employés
            </Typography>
            <Typography
              sx={{ fontSize: ".75rem", color: C.accent, mt: ".15rem" }}
            >
              Réduction de 20 % sur le tarif cabinet
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: F.display,
              fontSize: "1.9rem",
              fontWeight: 300,
              color: C.text,
              whiteSpace: "nowrap",
            }}
          >
            44
            <Box
              component="sup"
              sx={{ fontSize: "1rem", fontWeight: 400, verticalAlign: "super" }}
            >
              €
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>

    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1rem", md: "2.5rem" },
        pb: "5rem",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: "1.25rem",
      }}
    >
      <Box
        sx={{
          background: C.surface,
          border: `1px solid ${C.border}`,
          borderRadius: R.lg,
          padding: "1.75rem",
        }}
      >
        <Typography
          sx={{
            fontSize: ".88rem",
            fontWeight: 600,
            color: C.text,
            mb: "1.1rem",
          }}
        >
          Modes de paiement
        </Typography>
        {[
          { location: "Balma", methods: "Chèques · Espèces · CB · Virement" },
          {
            location: "Castelnau-d'Estrétefonds",
            methods: (
              <span>
                Chèques · Espèces · Virement
                <br />
                <em>(cartes non acceptées)</em>
              </span>
            ),
          },
        ].map(({ location, methods }) => (
          <Box key={location} sx={{ mb: ".85rem" }}>
            <Typography
              sx={{
                fontSize: ".75rem",
                fontWeight: 600,
                color: C.accent,
                mb: ".2rem",
              }}
            >
              {location}
            </Typography>
            <Typography
              sx={{ fontSize: ".82rem", color: C.textMuted, lineHeight: 1.5 }}
            >
              {methods}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          background: C.surface,
          border: `1px solid ${C.border}`,
          borderRadius: R.lg,
          padding: "1.75rem",
        }}
      >
        <Typography
          sx={{
            fontSize: ".88rem",
            fontWeight: 600,
            color: C.text,
            mb: "1.1rem",
          }}
        >
          Mutuelles & remboursement
        </Typography>
        {[
          {
            sub: "Sécurité sociale",
            text: "Non remboursée l'absence de tarification permet une prise en charge plus complète.",
          },
          {
            sub: "Mutuelles",
            text: "La plupart prennent en charge tout ou partie. Facture sur demande.",
          },
        ].map(({ sub, text }) => (
          <Box key={sub} sx={{ mb: ".85rem" }}>
            <Typography
              sx={{
                fontSize: ".78rem",
                fontWeight: 600,
                color: C.text,
                mb: ".2rem",
              }}
            >
              {sub}
            </Typography>
            <Typography
              sx={{ fontSize: ".8rem", color: C.textMuted, lineHeight: 1.6 }}
            >
              {text}
            </Typography>
          </Box>
        ))}
        <Typography
          sx={{
            fontSize: ".8rem",
            color: C.textMuted,
            pt: ".85rem",
            borderTop: `1px solid ${C.border}`,
          }}
        >
          Des questions sur les remboursements ?{" "}
          <Box
            component={Link}
            to="/faq"
            sx={{
              color: C.primary,
              textDecoration: "none",
              fontWeight: 500,
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Consultez notre FAQ
          </Box>
          .
        </Typography>
      </Box>
    </Box>
  </>
);

export default TarifsRemboursements;
